import React from 'react';
import FormField from '../swedish-private-v2/form-field';
import { Card } from '../../common/form/form-parts';
import { Button } from 'tradera/components/atoms/button/button';

export const AutoFilledPersonalDetails = (props) => {
    const { form, onChangePerson } = props;
    return (
        <Card padding={true} className="bg-info mb-2">
            {onChangePerson && (
                <p>
                    <Button theme="link" onClick={onChangePerson}>
                        Inte du?
                    </Button>
                </p>
            )}
            <address className="sentry-mask">
                <p className="font-weight-bold mb-0">
                    {form.get('FirstName')} {form.get('LastName')}
                </p>
                <p className="mb-0">{form.get('StreetName')}</p>
                <p className="mb-2">
                    {form.get('ZipCode')} {form.get('Town')}
                </p>
            </address>
            <FormField
                type="text"
                containerClassName="mb-2"
                form={form}
                field="PhoneNumber"
                placeholder="Ditt mobilnummer"
                hint="Ditt telefonnummer behövs ifall du skulle behöva återställa ditt lösenord."
            />
            <p className="mb-0 text-left">
                Informationen är hämtad från publika källor. Du har möjlighet
                att ändra dina uppgifter senare under Inställningar
            </p>
        </Card>
    );
};
